import { request } from './request';
import * as PATHS from '@/constants/path';
import { URLParamBuilder } from '@/utils/functions';
import { BookingPageModel } from '@/typings/models/BookingPage';

export function fetchBookingPagesRequest({ params }: { params: { userId: string } }) {
  const url = URLParamBuilder(PATHS.GET_BOOKING_LINKS_API_PATH, {
    params,
  });

  return request<BookingPageModel[]>(url, {
    method: 'GET',
  });
}

export function createBookingPageRequest({
  params,
  data,
}: {
  params: { userId: string };
  data: Partial<BookingPageModel>;
}) {
  const url = URLParamBuilder(PATHS.CREATE_BOOKING_LINK_API_PATH, {
    params,
  });

  return request<BookingPageModel>(url, {
    method: 'POST',
    data,
  });
}

export function editBookingPageRequest({
  params,
  data,
}: {
  params: { bookingLinkId: string };
  data: Partial<BookingPageModel>;
}) {
  const url = URLParamBuilder(PATHS.EDIT_BOOKING_LINK_API_PATH, {
    params,
  });

  return request<BookingPageModel>(url, {
    method: 'PATCH',
    data,
  });
}

export function deleteBookingPageRequest({ params }: { params: { bookingLinkId: string } }) {
  const url = URLParamBuilder(PATHS.DELETE_BOOKING_LINK_API_PATH, {
    params,
  });

  return request<{ success: boolean }>(url, {
    method: 'DELETE',
  });
}
